import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Layout from "../../Components/layouts";
import AssignLicence from "./Components/AssignLicence";
import Customer from "./Components/Customer";
import CustomerAdmin from "./Components/CustomerAdmin";
import Project from "./Components/Project";
import ProjectAllocation from "./Components/ProjectAllocation";
import Users from "./Components/Users";
import AllocateLicence from "./Components/AllocateLicence";
import ProjectSummary from "./Components/ProjectSummary";
import {
    Stepper,
    Step,
    StepLabel,
    StepConnector,
    Typography,
    CircularProgress,
    MenuItem,
    TextField,
} from '@material-ui/core';
import { CustomerServices } from '../../Services/CustomerServices';
import { ProjectServices } from '../../Services/ProjectServices';
import CheckIcon from '@material-ui/icons/Check';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { useHistory, useLocation, useParams } from 'react-router';
import { Paths } from 'Routes/routePaths';
import { notify } from 'utils';
import commonStyles from 'theme/commonStyles';
import { areAllOnboardingStepsComplete, getSavedLicenceFlowStage } from './flowProgress';
import { scrollToPageTop } from './scrollToPageTop';

const customerServices = new CustomerServices();
const projectServices = new ProjectServices();

export const useStyle = makeStyles((theme) => ({
    root: {
        border: `8px solid ${theme.palette.common.white}`,
        margin: 16,
        padding: "36px 0 0",
        background: `rgba(255,255,255,0.9)`,
        boxShadow: [
            `0px 16px 26px -10px ${theme.palette.primary.main}99`,
            theme.shadows[15]
        ],
        maxWidth: '100%',
        boxSizing: 'border-box',
        overflowX: 'hidden',
        [theme.breakpoints.down('sm')]: {
            margin: 8,
            padding: "24px 0 0",
        },
        [theme.breakpoints.down('xs')]: {
            margin: 4,
            padding: "16px 0 0",
        },
    },
    stepper: {
        padding: theme.spacing(2.5, 3),
        overflow: "auto",
        width: '100%',
        backgroundColor: '#ffffff',
        borderTop: '1px solid #e7ebf0',
        borderBottom: '1px solid #e7ebf0',
        boxSizing: 'border-box',
        '& .MuiStep-root': {
            minWidth: 132,
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
        },
        '& .MuiStepLabel-alternativeLabel': {
            marginTop: theme.spacing(1),
        },
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2, 1.5),
        },
    },
    stepConnector: {
        top: 15,
        left: '-50%',
        right: '50%',
        display: 'flex',
        justifyContent: 'center',
        '& .MuiStepConnector-line': {
            borderColor: '#d9e0e8',
            borderTopWidth: 2,
            borderRadius: 2,
            width: 62,
            transform: 'translateY(15px)',
        },
    },
    stepConnectorActive: {
        '& .MuiStepConnector-line': {
            borderColor: theme.palette.primary.main,
        },
    },
    stepConnectorCompleted: {
        '& .MuiStepConnector-line': {
            borderColor: theme.palette.primary.main,
        },
    },
    stepIcon: {
        width: 32,
        height: 32,
        borderRadius: '50%',
        border: '1px solid #b8c2cf',
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 13,
        fontWeight: 700,
        color: '#697586',
    },
    stepIconActive: {
        border: `2px solid ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
        boxShadow: '0 0 0 4px rgba(61, 125, 221, 0.16)',
    },
    stepIconCompleted: {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    stepLabel: {
        '& .MuiStepLabel-label': {
            fontSize: '0.75rem',
            fontWeight: 600,
            color: '#697586',
        },
        '& .MuiStepLabel-label.MuiStepLabel-completed': {
            color: theme.palette.primary.main,
        },
        '& .MuiStepLabel-label.MuiStepLabel-active': {
            color: '#1f4f91',
            fontWeight: 700,
        },
    },
    stepCurrent: {
        '& .MuiStepLabel-labelContainer': {
            backgroundColor: '#eef5fd',
            borderRadius: 4,
            padding: theme.spacing(0.5, 0.75),
        },
        '& .MuiStepLabel-labelContainer span:last-child': {
            color: '#4f6f94',
            fontWeight: 600,
        },
    },
    stepClickable: {
        cursor: 'pointer',
    },
    navigation: {
        width: 110,
        fontSize: 12,
        [theme.breakpoints.down("xs")]: {
            fontSize: 10,
            width: 90
        }
    },
    prevBtn: {
        color: theme.palette.grey[700],
        background: theme.palette.common.white,
        boxShadow: theme.shadows[5]
    },
    buttons: {
        display: 'flex',
        width: '100%',
        maxWidth: 'none',
        boxSizing: 'border-box',
    },
    button: {
        marginTop: theme.spacing(3),
        minWidth: 120,
        [theme.breakpoints.down('xs')]: {
            minWidth: 96,
        },
    },
    cancelBtn: {
        marginTop: theme.spacing(3),
        minWidth: 120,
        [theme.breakpoints.down('xs')]: {
            minWidth: 96,
        },
    },
    wrapper: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'nowrap',
        width: '100%',
        gap: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    formGrid: {
        [theme.breakpoints.down('sm')]: {
            padding: '12px !important',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '8px !important',
        },
    },
    pageWrapper: {
        maxWidth: '100%',
        overflowX: 'hidden',
        boxSizing: 'border-box',
        fontFamily: 'Inter, sans-serif',
        backgroundColor: '#f4f7fa',
        border: '1px solid #e1e7ee',
        borderRadius: 6,
        boxShadow: '0 3px 18px rgba(30, 48, 70, 0.07)',
        '& .MuiTypography-root, & .MuiButton-root, & .MuiTab-root, & .MuiInputBase-root, & .MuiInputBase-input, & .MuiInputLabel-root, & .MuiFormLabel-root, & .MuiFormControlLabel-label, & .MuiTableCell-root, & .MuiTableSortLabel-root, & .MuiStepLabel-label, & .MuiChip-root, & .MuiSelect-root, & .MuiAutocomplete-input': {
            fontFamily: 'Inter, sans-serif',
        },
    },
    pageHeader: {
        padding: theme.spacing(2.5, 3),
        backgroundColor: '#ffffff',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    breadcrumb: {
        color: '#718096',
        fontSize: '0.75rem',
        fontWeight: 500,
        marginBottom: theme.spacing(1),
    },
    titleRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        flexWrap: 'wrap',
    },
    pageTitle: {
        color: '#1f2937',
        fontSize: '1.5rem',
        fontWeight: 700,
        lineHeight: 1.3,
    },
    titleActions: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        flexWrap: 'wrap',
    },
    sectionJump: {
        minWidth: 210,
    },
    contextLabel: {
        color: '#49627e',
        fontSize: '0.75rem',
        fontWeight: 600,
        padding: theme.spacing(0.75, 1.25),
        backgroundColor: '#eef4fa',
        border: '1px solid #dbe7f2',
        borderRadius: 4,
    },
    stepLabelTitle: {
        display: 'block',
        color: 'inherit',
        fontSize: '0.75rem',
        fontWeight: 700,
        lineHeight: 1.35,
    },
    stepLabelCaption: {
        display: 'block',
        color: '#8a96a5',
        fontSize: '0.625rem',
        fontWeight: 500,
        lineHeight: 1.35,
        marginTop: 2,
    },
    formArea: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1.5),
        },
    },
    stepLayout: {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr) 292px',
        gridTemplateAreas: '"form summary"',
        gap: theme.spacing(3),
        alignItems: 'start',
        '@media (max-width: 1100px)': {
            gridTemplateColumns: 'minmax(0, 1fr)',
            gridTemplateAreas: '"summary" "form"',
        },
    },
    primaryContent: {
        gridArea: 'form',
        minWidth: 0,
        backgroundColor: '#ffffff',
        border: '1px solid #e1e7ee',
        borderRadius: 6,
        padding: theme.spacing(3),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    stepIntro: {
        paddingBottom: theme.spacing(2.5),
        marginBottom: theme.spacing(2.5),
        borderBottom: '1px solid #e7ebf0',
    },
    stepEyebrow: {
        color: theme.palette.primary.main,
        fontSize: '0.6875rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        marginBottom: theme.spacing(0.75),
    },
    stepTitle: {
        color: '#1f2937',
        fontSize: '1.375rem',
        fontWeight: 700,
        lineHeight: 1.35,
        marginBottom: theme.spacing(0.75),
    },
    stepDescription: {
        color: '#647184',
        fontSize: '0.875rem',
        lineHeight: 1.6,
        maxWidth: 700,
    },
    summaryPanel: {
        gridArea: 'summary',
        minWidth: 0,
        backgroundColor: '#f8fafc',
        borderLeft: '3px solid #dbe7f2',
        padding: theme.spacing(2.5),
        position: 'sticky',
        top: theme.spacing(2),
        '@media (max-width: 1100px)': {
            position: 'static',
            borderLeft: 0,
            borderTop: 0,
            borderBottom: '3px solid #dbe7f2',
        },
    },
    summaryTitle: {
        color: '#263548',
        fontSize: '0.9375rem',
        fontWeight: 700,
        marginBottom: theme.spacing(0.5),
    },
    summaryHint: {
        color: '#7a8797',
        fontSize: '0.6875rem',
        lineHeight: 1.5,
        marginBottom: theme.spacing(2),
    },
    summaryRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(1.15, 0),
        borderBottom: '1px solid #e4e9ef',
    },
    summaryLabel: {
        color: '#4a586a',
        fontSize: '0.75rem',
        lineHeight: 1.4,
        flex: 1,
        minWidth: 0,
    },
    summaryCompanyName: {
        color: '#263548',
        fontSize: '0.875rem',
        fontWeight: 700,
        lineHeight: 1.3,
        textAlign: 'right',
        whiteSpace: 'normal',
    },
    summaryStatus: {
        color: '#8692a1',
        fontSize: '0.6875rem',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        textAlign: 'right',
    },
    summaryStatusActive: {
        color: theme.palette.primary.main,
    },
    summaryStatusComplete: {
        color: '#287a4b',
    },
    summaryStatusUnknown: {
        color: '#9a6700',
    },
    summaryLoading: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        color: '#7a8797',
        fontSize: '0.6875rem',
        marginBottom: theme.spacing(1),
    },
    flowGuide: {
        marginTop: theme.spacing(2.5),
        paddingTop: theme.spacing(2),
        borderTop: '1px solid var(--dm-border, #dce3eb)',
    },
    flowTitle: {
        color: 'var(--dm-text-strong, #263548)',
        fontSize: '0.875rem',
        fontWeight: 700,
        marginBottom: theme.spacing(1.5),
    },
    flowList: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
    },
    flowItem: {
        width: '100%',
        boxSizing: 'border-box',
        padding: theme.spacing(1.35, 1.5),
        border: '1px solid var(--dm-border, #cfd9e5)',
        borderRadius: 10,
        backgroundColor: 'var(--contentColor, #ffffff)',
        transition: 'background-color 180ms ease, border-color 180ms ease, color 180ms ease, box-shadow 180ms ease',
    },
    flowItemActive: {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.main,
        boxShadow: '0 8px 18px rgba(30, 70, 160, 0.18)',
    },
    flowItemTitle: {
        display: 'block',
        color: 'var(--dm-text-strong, #263548)',
        fontSize: '0.8125rem',
        fontWeight: 700,
        lineHeight: 1.35,
    },
    flowItemDetail: {
        display: 'block',
        color: 'var(--dm-muted, #647184)',
        fontSize: '0.6875rem',
        lineHeight: 1.45,
        marginTop: 2,
    },
    flowItemTextActive: {
        color: '#ffffff',
    },
    flowArrow: {
        color: '#2b94cf',
        fontSize: 20,
        margin: theme.spacing(0.65, 0),
    },
    standardContent: {
        gridArea: 'form',
        minWidth: 0,
        backgroundColor: '#ffffff',
        border: '1px solid #e1e7ee',
        borderRadius: 6,
        padding: theme.spacing(2.5),
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%'
    },
}));

const RenderStepContent = ({
    step,
    handleNext,
    handleCancel,
    handleBack,
    countryList,
    apprenticeshipList,
    coursesList,
    handleUpdateBackupFormData,
    formBackupState,
    assessmentList,
    handleEditTab,
    onGoToStep,
    labsList,
    talentDialogOpen,
    setTalentDialogOpen,
    handleCompleteOnboarding,
    completionLoading,
    customerId,
    customer,
    customerLoading,
    onboardingProgress,
    isExistingCustomer,
}) => {

    switch (step) {
        case 0:
            return <Customer
                handleNext={handleNext}
                handleCancel={handleCancel}
                countryList={countryList}
                activeStep={step}
                handleBack={handleBack}
                formBackupState={formBackupState.customer}
                handleUpdateBackupFormData={handleUpdateBackupFormData}
                talentDialogOpen={talentDialogOpen}
                setTalentDialogOpen={setTalentDialogOpen}
            />;
        case 1:
            return <AssignLicence
                handleNext={handleNext}
                activeStep={step}
                handleBack={handleBack}
                apprenticeshipList={apprenticeshipList}
                coursesList={coursesList}
                labsList={labsList}
                assessmentList={assessmentList}
                formBackupState={formBackupState.assignLicence}
                handleUpdateBackupFormData={handleUpdateBackupFormData}
            />;
        case 2:
            return <CustomerAdmin
                handleNext={handleNext}
                activeStep={step}
                handleBack={handleBack}
                formBackupState={formBackupState.customerAdmin}
                handleUpdateBackupFormData={handleUpdateBackupFormData}
            />;
        case 3:
            return <Project
                handleNext={handleNext}
                activeStep={step}
                handleBack={handleBack}
                formBackupState={formBackupState.project}
            />;
        case 4:
            return <ProjectAllocation
                handleNext={handleNext}
                activeStep={step}
                handleBack={handleBack}
            />;
        case 5:
            return <Users
                handleNext={handleNext}
                activeStep={step}
                handleBack={handleBack}
                formBackupState={formBackupState.user}
                handleUpdateBackupFormData={handleUpdateBackupFormData}
            />;
        case 6:
            return <AllocateLicence
                handleNext={handleNext}
                activeStep={step}
                handleBack={handleBack}
                onGoToStep={onGoToStep}
                formBackupState={formBackupState.allocateLicenses}
                handleUpdateBackupFormData={handleUpdateBackupFormData}
            />;
        case 7:
            return <ProjectSummary
                customerId={customerId}
                customer={customer}
                customerLoading={customerLoading}
                onboardingProgress={onboardingProgress}
                activeStep={step}
                handleBack={handleBack}
                handleCancel={handleCancel}
                handleEditTab={handleEditTab}
                handleCompleteOnboarding={handleCompleteOnboarding}
                completionLoading={completionLoading}
                isExistingCustomer={isExistingCustomer}
            />;
        default:
            return null;
    }
}

const steps = [
    { key: 'customer_details', label: 'Customer', caption: 'Company details' },
    { key: 'licences', label: 'Licences', caption: 'Provision services' },
    { key: 'administrator', label: 'Administrator', caption: 'Customer admin' },
    { key: 'projects', label: 'Projects', caption: 'Projects & admins' },
    { key: 'allocation', label: 'Allocation', caption: 'Licences to projects' },
    { key: 'users', label: 'Users', caption: 'Add users' },
    { key: 'assignment', label: 'Assignment', caption: 'Licences to users' },
    { key: 'review', label: 'Review', caption: 'Confirm details' },
];

const tabs = steps.map(({ label }) => label);

/** Review "Edit" links and the header section jump use these targets. */
export const EDIT_TARGETS = {
    customer: { step: 'customer_details', label: 'Customer information' },
    licences: { step: 'licences', label: 'Licences' },
    administrator: { step: 'administrator', label: 'Administrators' },
    project: { step: 'projects', label: 'Projects' },
    allocation: { step: 'allocation', label: 'Allocation' },
    users: { step: 'users', label: 'Users' },
    assignment: { step: 'assignment', label: 'Assignments' },
    learning_hub: { step: 'projects', section: 'learning_hub', label: 'Learning Hub' },
    review: { step: 'review', label: 'Review' },
};

const getStepIndexFromSearch = (search) => {
    const stepKey = new URLSearchParams(search).get('step');
    const stepIndex = steps.findIndex(step => step.key === stepKey);
    return stepIndex >= 0 ? stepIndex : 0;
};

const summaryItems = [
    { key: 'customer_details', label: 'Customer details' },
    { key: 'licences', label: 'Licences provisioned' },
    { key: 'administrator', label: 'Customer administrators' },
    { key: 'projects', label: 'Projects' },
    { key: 'allocation', label: 'Licences allocated' },
    { key: 'users', label: 'Users' },
    { key: 'assignment', label: 'Licences assigned' },
    { key: 'review', label: 'Review' },
];

const statusLabels = {
    complete: 'Complete',
    in_progress: 'In progress',
    pending: 'Pending',
    skipped: 'Skipped',
    unknown: 'Not recorded',
    unavailable: 'Unavailable',
    checking: 'Checking',
};

const CustomerOnBoarding = () => {

    const classes = useStyle();
    const commonClasses = commonStyles();
    const { id: uuid } = useParams();
    const history = useHistory();
    const location = useLocation();

    const [countryList, setCountryList] = useState([]);
    const [activeStep, setActiveStep] = useState(() => (
        uuid ? getStepIndexFromSearch(location.search) : 0
    ));
    const [apprenticeshipList, setApprenticeshipList] = useState([]);
    const [assessmentList, setAssessmentList] = useState([]);
    const [coursesList, setCoursesList] = useState([]);
    const [labsList, setLabsList] = useState([]);
    const [formBackupState, setFormBackupState] = useState({
        customer: null,
        assignLicence: null,
        customerAdmin: null,
        project: null,
        user: null,
        allocateLicenses: null,
        projectSummery: null
    });
    const [talentDialogOpen, setTalentDialogOpen] = useState(false);
    const [onboardingProgress, setOnboardingProgress] = useState(null);
    const [progressLoading, setProgressLoading] = useState(!!uuid);
    const [progressError, setProgressError] = useState('');
    const [completionLoading, setCompletionLoading] = useState(false);
    const [companyName, setCompanyName] = useState('');
    const [customerDetail, setCustomerDetail] = useState(null);
    const [customerDetailLoading, setCustomerDetailLoading] = useState(!!uuid);
    const countriesRequested = React.useRef(false);
    const licenceDropdownsRequested = React.useRef(false);

    const refreshOnboardingProgress = React.useCallback(async (customerId) => {
        if (!customerId) {
            setOnboardingProgress(null);
            setProgressError('');
            setProgressLoading(false);
            return;
        }
        setProgressLoading(true);
        const result = await customerServices.getCustomerOnboardingStatus(customerId);
        if (result && result.status && result.data && Array.isArray(result.data.steps)) {
            setOnboardingProgress(result.data);
            setProgressError('');
        } else {
            setOnboardingProgress(null);
            setProgressError(result?.message || 'Onboarding status is unavailable.');
        }
        setProgressLoading(false);
    }, []);

    React.useEffect(() => {
        let cancelled = false;
        clearLocalStorageItem();
        if (uuid) {
            localStorage.setItem('getAllCustomer', true);
            refreshOnboardingProgress(uuid);
            setCustomerDetailLoading(true);
            customerServices.getCustomerDetail(uuid)
                .then((result) => {
                    if (cancelled) return;
                    const detail = result?.data?.[0] || null;
                    const name = detail?.name;
                    setCustomerDetail(detail);
                    setCompanyName(typeof name === 'string' ? name.trim() : '');
                })
                .catch(() => {
                    if (!cancelled) {
                        setCustomerDetail(null);
                        setCompanyName('');
                    }
                })
                .finally(() => {
                    if (!cancelled) setCustomerDetailLoading(false);
                });
        } else {
            refreshOnboardingProgress(null);
            setCompanyName('');
            setCustomerDetail(null);
            setCustomerDetailLoading(false);
        }

        return () => {
            cancelled = true;
        };
    }, [refreshOnboardingProgress, uuid]);

    React.useEffect(() => {
        if (activeStep !== 0 || countriesRequested.current) return;
        countriesRequested.current = true;
        customerServices.getCounties()
            .then((countries) => setCountryList(countries?.country_list || []))
            .catch(() => {
                countriesRequested.current = false;
            });
    }, [activeStep]);

    React.useEffect(() => {
        if (activeStep !== 1 || licenceDropdownsRequested.current) return;
        licenceDropdownsRequested.current = true;

        const courseRequest = uuid
            ? Promise.resolve(null)
            : projectServices.getCoursesList();

        Promise.all([
            projectServices.getApprenticeshipsList(),
            projectServices.getAssessmentsList(),
            courseRequest,
            projectServices.getLabsList(null, '?limit=10000'),
        ]).then(([apprenticeshipResult, assessmentResult, courseResult, labsResult]) => {
            setApprenticeshipList(apprenticeshipResult?.data || []);

            const validAssessments = [
                'Digital Readiness Assessment',
                'GC Index',
                'Work Readiness',
                'Digital Talent Maturity Model',
                'AI Maturity Model',
            ];
            setAssessmentList((assessmentResult?.data || []).filter(assessment => (
                validAssessments.includes(assessment.name)
            )));

            if (courseResult?.data) {
                setCoursesList(courseResult.data.map(course => ({
                    id: course.uuid,
                    name: course.provider === 'Xpert Skills'
                        ? `${course.course} - ${course.provider}`
                        : course.course,
                })));
            }

            setLabsList((labsResult?.results || []).map(lab => ({
                id: lab.uuid,
                name: lab.name,
            })));
        }).catch(() => {
            licenceDropdownsRequested.current = false;
        });
    }, [activeStep, uuid]);

    React.useEffect(() => {
        const requestedStep = uuid ? getStepIndexFromSearch(location.search) : 0;
        setActiveStep(currentStep => currentStep === requestedStep ? currentStep : requestedStep);
    }, [location.search, uuid]);

    React.useEffect(() => {
        localStorage.setItem('editstep', activeStep);
    }, [activeStep, uuid]);

    const requestedProjectId = uuid ? new URLSearchParams(location.search).get('project_id') : null;
    React.useEffect(() => {
        // Steps pick their working project from localStorage once their project list loads.
        if (requestedProjectId) localStorage.setItem('project_id', requestedProjectId);
    }, [requestedProjectId]);

    React.useEffect(() => {
        if (!uuid) return;
        const params = new URLSearchParams(location.search);
        const hasValidStep = steps.some(step => step.key === params.get('step'));
        if (hasValidStep) return;
        params.set('step', steps[activeStep].key);
        history.replace({
            pathname: location.pathname,
            search: `?${params.toString()}`,
        });
    }, [activeStep, history, location.pathname, location.search, uuid]);

    const goToStep = (stepIndex, { projectId, section } = {}) => {
        const nextStep = Math.max(0, Math.min(stepIndex, steps.length - 1));
        const customerId = uuid || localStorage.getItem('customerUUID');
        const params = new URLSearchParams(location.search);
        params.set('step', steps[nextStep].key);
        if (projectId) params.set('project_id', projectId);
        else params.delete('project_id');
        if (section) params.set('section', section);
        else params.delete('section');

        setActiveStep(nextStep);
        history.push({
            pathname: customerId ? `/flowcustomer/${customerId}` : location.pathname,
            search: `?${params.toString()}`,
        });
        scrollToPageTop();
    };

    const handleEditTab = (action, { projectId } = {}) => {
        if (action === 'project' || action === 'learning_hub') localStorage.setItem('project_edit', true);
        const target = EDIT_TARGETS[action] || EDIT_TARGETS.users;
        goToStepKey(target.step, { projectId, section: target.section });
    }

    const clearLocalStorageItem = () => {
        localStorage.removeItem('editstep');
        localStorage.removeItem('assign_lecense');
        localStorage.removeItem('refreshlic');
        localStorage.removeItem('cstmsrSaveFlow');
        localStorage.removeItem('customerUUID');
        localStorage.removeItem('getAllCustomer');
        localStorage.removeItem('created_user_id');
    }

    const isLastStep = activeStep === tabs.length - 1;
    const savedCustomerId = uuid || localStorage.getItem('customerUUID');
    const progressStepsByKey = (onboardingProgress?.steps || []).reduce((items, item) => {
        if (item && item.key) items[item.key] = item;
        return items;
    }, {});

    const getOnboardingStepStatus = (key, index) => {
        const progressKey = key === 'allocation' && !progressStepsByKey.allocation ? 'projects' : key;
        if (progressStepsByKey[progressKey]?.status) return progressStepsByKey[progressKey].status;
        if (!savedCustomerId) return index === 0 ? 'in_progress' : 'pending';
        if (progressLoading) return 'checking';
        if (progressError) return 'unavailable';
        return 'unknown';
    };

    const activeLicenceFlowStage = getSavedLicenceFlowStage(onboardingProgress);
    const licenceFlowStages = [
        {
            title: 'Customer pool',
            detail: 'Licences provisioned to the customer',
        },
        {
            title: 'Project',
            detail: 'Pool allocated to each project',
        },
        {
            title: 'User',
            detail: 'Licences assigned to people',
        },
    ];

    const handleBack = () => {
        goToStep(activeStep - 1);
    }

    const goToStepKey = (key, options) => {
        const index = steps.findIndex(step => step.key === key);
        if (index >= 0) goToStep(index, options);
    };

    const handleSubmit = (e) => {
        if (e) e.preventDefault();
        if (!isLastStep) {
            goToStep(activeStep + 1);
            const customerId = uuid || localStorage.getItem('customerUUID');
            if (customerId) refreshOnboardingProgress(customerId);
            return null;
        }
        return handleCompleteOnboarding();
    };

    const handleCompleteOnboarding = async () => {
        const customerId = uuid || localStorage.getItem('customerUUID');
        if (!customerId) {
            notify('error', 'Save the customer before completing onboarding.');
            return;
        }
        setCompletionLoading(true);
        const result = await customerServices.completeCustomerOnboarding(customerId);
        if (result && result.status) {
            notify('success', result.message || 'Customer onboarding completed successfully.');
            history.push(Paths.Customers);
        } else {
            const blockers = Array.isArray(result?.data?.blockers)
                ? result.data.blockers.map(item => item?.message).filter(Boolean).join(' ')
                : '';
            notify('error', [result?.message || 'Customer onboarding could not be completed.', blockers].filter(Boolean).join(' '));
            await refreshOnboardingProgress(customerId);
            setCompletionLoading(false);
        }
    };

    const handleUpdateBackupFormData = (formData, action) => {
        setFormBackupState({ ...formBackupState, [action]: formData });
    }

    const savedStepStatuses = steps.map((step, index) => getOnboardingStepStatus(step.key, index));
    const onboardingStepsComplete = onboardingProgress?.overall_status === 'completed'
        || areAllOnboardingStepsComplete(savedStepStatuses);
    const canGoToStep = (index) => Boolean(
        savedCustomerId
        && (index < steps.length - 1 || (index === steps.length - 1 && onboardingStepsComplete))
    );
    const handleStepClick = (index) => {
        if (canGoToStep(index)) goToStep(index);
    };

    const handleCancel = () => {
        history.push(Paths.Customers);
    };

    const StepIcon = ({ active, completed, icon }) => {
        const iconClasses = [
            classes.stepIcon,
            completed && classes.stepIconCompleted,
            active && classes.stepIconActive,
        ].filter(Boolean).join(' ');
        return (
            <div className={iconClasses}>
                {completed && !active ? <CheckIcon style={{ fontSize: 16 }} /> : icon}
            </div>
        );
    };

    return (
        <Layout>
            <main>
                <div className={`${commonClasses.contentWrapper} ${classes.pageWrapper}`} style={{ padding: 0 }}>
                    <div className={classes.pageHeader}>
                        <Typography className={classes.breadcrumb}>
                            Customer Onboarding / {steps[activeStep].label}
                        </Typography>
                        <div className={classes.titleRow}>
                            <Typography component="h1" className={classes.pageTitle}>
                                {uuid ? 'Update customer onboarding' : 'Onboard a new customer'}
                            </Typography>
                            <div className={classes.titleActions}>
                                {savedCustomerId ? (
                                    <TextField
                                        select
                                        size="small"
                                        variant="outlined"
                                        label="Go to section"
                                        value=""
                                        className={classes.sectionJump}
                                        onChange={(event) => handleEditTab(event.target.value, {
                                            projectId: event.target.value === 'learning_hub' ? localStorage.getItem('project_id') || undefined : undefined,
                                        })}
                                        SelectProps={{ displayEmpty: true, renderValue: () => steps[activeStep].label }}
                                        InputLabelProps={{ shrink: true }}
                                    >
                                        {Object.entries(EDIT_TARGETS).map(([key, target]) => (
                                            <MenuItem
                                                key={key}
                                                value={key}
                                                disabled={key === 'review' && !canGoToStep(steps.length - 1)}
                                            >
                                                {target.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                ) : null}
                                <span className={classes.contextLabel}>
                                    {uuid ? 'Existing customer' : 'New customer'}
                                </span>
                            </div>
                        </div>
                    </div>
                    {!talentDialogOpen && (
                        <Stepper
                            activeStep={activeStep}
                            className={classes.stepper}
                            alternativeLabel
                            connector={
                                <StepConnector
                                    classes={{
                                        root: classes.stepConnector,
                                        active: classes.stepConnectorActive,
                                        completed: classes.stepConnectorCompleted,
                                    }}
                                />
                            }
                        >
                            {steps.map((item, index) => (
                                <Step
                                    key={item.label}
                                    completed={['complete', 'skipped'].includes(getOnboardingStepStatus(item.key, index))}
                                    onClick={() => handleStepClick(index)}
                                    aria-current={index === activeStep ? 'step' : undefined}
                                    className={[
                                        canGoToStep(index) && classes.stepClickable,
                                        index === activeStep && classes.stepCurrent,
                                    ].filter(Boolean).join(' ')}
                                >
                                    <StepLabel
                                        StepIconComponent={StepIcon}
                                        StepIconProps={{ icon: index + 1 }}
                                        classes={{ root: classes.stepLabel }}
                                >
                                    <span className={classes.stepLabelTitle}>{item.label}</span>
                                    <span className={classes.stepLabelCaption}>{item.caption}</span>
                                </StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    )}
                    <div className={classes.formArea}>
                        <div className={classes.stepLayout}>
                            <div className={activeStep === 0 ? classes.primaryContent : classes.standardContent}>
                                {activeStep === 0 && (
                                    <div className={classes.stepIntro}>
                                        <Typography className={classes.stepEyebrow}>Step 1 of {steps.length}</Typography>
                                        <Typography component="h2" className={classes.stepTitle}>Customer details</Typography>
                                        <Typography className={classes.stepDescription}>
                                            Capture the organisation information used across its projects, users and licences.
                                        </Typography>
                                    </div>
                                )}
                                <form onSubmit={handleSubmit}>
                                    <RenderStepContent
                                        step={activeStep}
                                        handleNext={handleSubmit}
                                        handleCancel={handleCancel}
                                        countryList={countryList}
                                        handleBack={handleBack}
                                        apprenticeshipList={apprenticeshipList}
                                        coursesList={coursesList}
                                        assessmentList={assessmentList}
                                        formBackupState={formBackupState}
                                        handleUpdateBackupFormData={handleUpdateBackupFormData}
                                        handleEditTab={handleEditTab}
                                        onGoToStep={goToStepKey}
                                        labsList={labsList}
                                        talentDialogOpen={talentDialogOpen}
                                        setTalentDialogOpen={setTalentDialogOpen}
                                        handleCompleteOnboarding={handleCompleteOnboarding}
                                        completionLoading={completionLoading}
                                        customerId={savedCustomerId}
                                        customer={customerDetail}
                                        customerLoading={customerDetailLoading}
                                        onboardingProgress={onboardingProgress}
                                        isExistingCustomer={Boolean(uuid)}
                                    />
                                </form>
                            </div>
                            <aside className={classes.summaryPanel} aria-label="Onboarding summary">
                                    <Typography className={classes.summaryTitle}>Onboarding summary</Typography>
                                    <Typography className={classes.summaryHint}>
                                        Saved progress across every onboarding step.
                                    </Typography>
                                    {progressLoading && savedCustomerId && (
                                        <div className={classes.summaryLoading}>
                                            <CircularProgress size={13} />
                                            Checking saved progress
                                        </div>
                                    )}
                                    {summaryItems.map((item, index) => {
                                        const status = getOnboardingStepStatus(item.key, index);
                                        const administratorCount = progressStepsByKey.administrator?.metadata?.count;
                                        const showCompanyName = item.key === 'customer_details' && companyName;
                                        const statusText = showCompanyName
                                            ? companyName
                                            : item.key === 'administrator'
                                                && administratorCount !== undefined
                                                && administratorCount !== null
                                                ? `${administratorCount} - ${statusLabels[status] || statusLabels.unknown}`
                                                : statusLabels[status] || statusLabels.unknown;
                                        const statusClass = showCompanyName
                                            ? classes.summaryCompanyName
                                            : status === 'complete'
                                                ? classes.summaryStatusComplete
                                                : status === 'in_progress'
                                                    ? classes.summaryStatusActive
                                                    : ['unknown', 'unavailable'].includes(status)
                                                        ? classes.summaryStatusUnknown
                                                        : '';
                                        return (
                                            <div className={classes.summaryRow} key={item.key}>
                                                <span className={classes.summaryLabel}>{item.label}</span>
                                                <span className={showCompanyName ? classes.summaryCompanyName : `${classes.summaryStatus} ${statusClass}`}>
                                                    {statusText}
                                                </span>
                                            </div>
                                        );
                                    })}
                                    <div className={classes.flowGuide}>
                                        <Typography className={classes.flowTitle}>How licences flow</Typography>
                                        <div className={classes.flowList}>
                                            {licenceFlowStages.map((stage, index) => {
                                                const isActive = index === activeLicenceFlowStage;
                                                const activeTextClass = isActive ? classes.flowItemTextActive : '';

                                                return (
                                                    <React.Fragment key={stage.title}>
                                                        <div
                                                            className={`${classes.flowItem} ${isActive ? classes.flowItemActive : ''}`}
                                                            aria-current={isActive ? 'step' : undefined}
                                                        >
                                                            <span className={`${classes.flowItemTitle} ${activeTextClass}`}>
                                                                {index + 1}. {stage.title}
                                                            </span>
                                                            <span className={`${classes.flowItemDetail} ${activeTextClass}`}>
                                                                {stage.detail}
                                                            </span>
                                                        </div>
                                                        {index < licenceFlowStages.length - 1 && (
                                                            <ArrowDownwardIcon className={classes.flowArrow} aria-hidden="true" />
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </aside>
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    );
}

export default CustomerOnBoarding;
